import { render } from "./TemplatePreview.vue?vue&type=template&id=495bac93"
import script from "./TemplatePreview.vue?vue&type=script&lang=js"
export * from "./TemplatePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__